import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/blindscommerce/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/blindscommerce/components/seo/RelatedBlogPosts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/gopal/BlindsCode/blindscommerce/node_modules/next/dist/client/app-dir/link.js");
